import React, { useEffect, useState } from 'react'
import HeaderTwo from './HeaderTwo'
import FooterTwo from './FooterTwo'
import { Styles } from "./styles/serviceBox.js";
import AboutUsTwo from './AboutUsTwo'

import State from './States'
import { GetApi, PostApi } from '../services/CommonService2.js';
import LoginModal from './LoginModal.js';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min.js';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';


function JobRoleComponent() {
    const [constituencySlider, setConstituencySlider] = useState("");
    const [modalUp, setModalUp] = useState(false)
    const [category, setCategory] = useState([])
    const [programs, setPrograms] = useState([])
    const [role, setRole] = useState([])

    const history = useHistory()
    const data = useLocation()


    useEffect(() => {
        getHomeBanners()
        getCategories()
        getTypes()
        eduData()
    }, [data.state])

    const getHomeBanners = async () => {
        const reqparam = {
            pageno: '-1',
            query: { status: 'Active' }
        }

        const intoContentData = await GetApi(reqparam, "INTRO");
        setConstituencySlider(intoContentData.data)
    }
    const partnerPage = async () => {
        var tntId = JSON.parse(localStorage.getItem('tID'))

        const userdata = JSON.parse(localStorage.getItem(`userdata${tntId}`))
        if (userdata == null) {
            setModalUp(true)
            toast.info('login to check course details', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
        else {
            history.push('/partner-onboard')
        }

    }

    const openModal = () => {
        setModalUp(false)
    }

    const logIn = () => {

    }

    const eduData = async () => {
        const reqparams = {
            pageno: '-1',
            query: { status: 'Active', _id: data?.state?.educationid },
        }

        const dataResponse = await PostApi(reqparams, 'EDUCATION');
        // console.log("The education response is", dataResponse?.data);
        setRole(dataResponse?.data[0])

    }

    const getCategories = async () => {
        const reqparam2 = {
            pageno: '-1',
            query: { status: 'Active', edutypeid: data.state.id }

        }
        let categoriesResponse = await PostApi(reqparam2, 'INDIVIDUALEDUPROGRAM');
        // console.log("Categories Resp", categoriesResponse);
        setCategory(categoriesResponse.data)
    }

    const getTypes = async () => {
        const reqparams3 = {
            pageno: "-1",
            query: { status: 'Active' },
            optimize: true
        }
        // reqparams3.query.program = { $elemMatch: { "value": { $in: categorySelectCheck } } };
        let response = await PostApi(reqparams3, 'STUDENTPROGRAM');
        // console.log("response", response.data);
        setPrograms(response.data)
    }

    const loginValidate = (data) => {
        var tntId = JSON.parse(localStorage.getItem('tID'))
        // console.log("data", data);

        const userdata = JSON.parse(localStorage.getItem(`userdata${tntId}`))
        if (userdata == null) {
            setModalUp(true)
            // e.preventDefault()

            toast.info('login to check course details', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
        else {
            localStorage.setItem('edutype', JSON.stringify('STUDENTPROGRAMMING'));
            history.push({
                pathname: "/lmspage2",
                state: data
            })
        }
    }
     let count = 1;


    return (
        <Styles>
            <div>
                <HeaderTwo />

                {constituencySlider.length != 0 && <div id="carouselExampleIndicators" class="carousel slide " data-bs-ride="carousel" onClick={partnerPage}>
                    <div class="carousel-inner mt-2" style={{ cursor: "pointer" }}>
                        {constituencySlider?.map((ele, ind) => {
                            if (ind == 0) {
                                return (
                                    <div className={ind == 0 ? "carousel-item active " : "carousel-item"} >
                                        <img src={ele.webicon} className="d-block" alt="..." />
                                    </div>
                                )
                            }

                        })}

                    </div>
                </div>
                }


                <div className='mt-3'>
                    <h3 style={{ textAlign: "center", fontWeight: "bold" }}>{role?.name}</h3>
                </div>


                <div className='jobroles'>
                    <div className="grid">
                        {category?.map((item, ind) => {
                            const filterprograms = programs?.filter(sub =>
                                sub.program?.some(programItem => programItem.value === item.id)
                            );
                            
                            return (
                                <React.Fragment key={ind}>
                                    {filterprograms?.map((ele, index) => {
                                        let imageid = 'https://visualpathedu.com/static/media/4th-year.15b862d606512e3257c0.jpg';
                                        if (ele?.image) {
                                            imageid = ele.image;
                                        } else if (ele?.image_url) {
                                            imageid = ele.image_url;
                                        }
                                        else if (ele?.imageurl) {
                                            imageid = ele.imageurl ? ele.imageurl : "";
                                        }
                                       return ( <div className="course-button" key={index}>
                                            <div className="image-wrapper" onClick={() => loginValidate(ele)}>
                                                <img src={imageid || '/default-course.jpg'} alt={ele.name} />
                                               <span className="badge">{count++}</span>
                                            </div>
                                           
                                        </div>)
                                    })}
                                </React.Fragment>
                            );
                        })}
                    </div>
                </div>




                <FooterTwo />

            </div>

            {modalUp && <LoginModal onClose={openModal} login={logIn}></LoginModal>}
        </Styles>
    )
}

export default JobRoleComponent